export default __webpack_public_path__ + "static/media/about-002.e90df945.webp";